import { FETCH_EVENTS, NO_EVENTS } from '../../_actions/types';

const defaultState = {
  open: false,
  start: '',
  time:'',
  end: '',
  desc: '',
  allEvents: []
};

export default function (state = defaultState, action) {
  switch(action.type) {
    case FETCH_EVENTS:
      return {...state, allEvents: action.payload }
    case NO_EVENTS:
      return { ...state }
    default:
      return { ...state}
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/calendar_reducer.js